import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import styled, { css } from 'styled-components';
import scrollTop from 'dom101/scroll-top';
import plant from 'images/floaters/plant.png';
import camera from 'images/floaters/camera.png';
import coffee from 'images/floaters/coffee.png';

const getOffsetTop = el => {
  const rect = el.getBoundingClientRect();
  return rect.top + scrollTop();
};

// prettier-ignore
const FloaterPositioner = styled.div`
  position: absolute;
  z-index: 900;
  top: 0;
  width: ${props => props.windowWidth / 2}px;
  min-width: 250px;
  max-width: 600px;
  ${props => props.img === 'camera' && css`
    left: 0;
    transform: translate(-50%, -50%);
  `}

  ${props => props.img === 'plant' && css`
    right: 0;
    transform: translate(50%, -100%);
  `}

  ${props => props.img === 'coffee' && css`
    transform: translate(-50%, -50%);
  `}

  img {
    width: 100%;
  }
`

const StyledFloater = styled.div`
  transform: translateY(${props => props.transformValue}px);
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
`;

const images = { plant, coffee, camera };

export default class Floater extends React.Component {
  static propTypes = {
    img: PropTypes.oneOf(Object.keys(images)).isRequired,
    ratio: PropTypes.number,
  };

  static defaultProps = {
    ratio: 0.15,
  };

  constructor(props) {
    super(props);
    this.throttledUpdate = throttle(this.updateTransformValue, 100);
    this.throttledResize = throttle(this.updateWindowWidth, 100);
  }

  state = { transformValue: 0, windowWidth: 0 };

  componentDidMount() {
    window.addEventListener('scroll', this.throttledUpdate);
    window.addEventListener('resize', this.throttledResize);
    this.updateTransformValue();
    this.updateWindowWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledUpdate);
    window.removeEventListener('resize', this.throttledResize);
  }

  updateTransformValue = () => {
    const offsetTop = getOffsetTop(this.container);
    const winHeight = window.outerHeight;
    const offset = 0;
    const { ratio } = this.props;

    this.setState({
      transformValue: Math.round(
        (offsetTop - winHeight / 2 - scrollTop()) * ratio - offset,
      ),
    });
  };

  updateWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  render() {
    const { windowWidth } = this.state;
    const { img } = this.props;

    return (
      <FloaterPositioner windowWidth={windowWidth} img={img}>
        <StyledFloater
          innerRef={el => {
            this.container = el;
          }}
          transformValue={this.state.transformValue}
        >
          <img src={images[this.props.img]} alt="Floating" />
        </StyledFloater>
      </FloaterPositioner>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Floater/Floater.jsx